module.exports = __webpack_public_path__ + "static/web-7-cb25d54f2300491d79cff6265e21f99f.mp4";